<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    帮助和反馈
  </div>


</template>

<script>
import axios from "axios";

export default {
  name: 'circleManager',
  components:{

  },
  data () {
    return {
      list: [],//日记列表
      layerShow:false
    }
  },
  mounted(){//页面加载后，调用接口数据


  },
  methods:{



  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
  //@import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  a{text-decoration: none;margin-top:50px;font-size:24px;color:royalblue}

</style>



// WEBPACK FOOTER //
// src/pages/pc/helpPage.vue